/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Social_Media_Url_PlaceholderInputs */

const en_company_profile_social_media_url_placeholder = /** @type {(inputs: Company_Profile_Social_Media_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL or username`)
};

const de_company_profile_social_media_url_placeholder = /** @type {(inputs: Company_Profile_Social_Media_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL oder Benutzername`)
};

/**
* | output |
* | --- |
* | "URL or username" |
*
* @param {Company_Profile_Social_Media_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_social_media_url_placeholder = /** @type {((inputs?: Company_Profile_Social_Media_Url_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Social_Media_Url_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_social_media_url_placeholder(inputs)
	return en_company_profile_social_media_url_placeholder(inputs)
});